import {
    buildResultList,
    buildFacet,
    buildCategoryFacet,
    buildSearchBox,
    loadAdvancedSearchQueryActions,
    loadPaginationActions,
    loadQueryActions,
    loadSearchActions,
    loadSearchAnalyticsActions,
    loadStandaloneSearchBoxSetActions,
    loadQuerySuggestActions,
    HighlightUtils
} from '@coveo/headless';
const randomID = (e, t = 5) =>
    e +
    Math.random()
        .toString(36)
        .substr(2, 2 + t);
export function buildOtherSuggestion(e, t, r, n, o) {
    let i;
    return (
        'buildResultList' === r
            ? (i = buildResultList(e, o))
            : 'buildFacet' === r
            ? (i = buildFacet(e, { options: { ...(null == o ? void 0 : o.options) } }))
            : 'buildCategoryFacet' === r &&
              (i = buildCategoryFacet(e, { options: { ...(null == o ? void 0 : o.options) } })),
        { engine: e, groupName: t, controller: i, controllerType: r, filter: n, lastFirstSuggestion: '', props: o }
    );
}
export function buildCustomSearchBox(e, t, r, n) {
    var o;
    const i = {
            options: {
                id: (null === (o = t.options) || void 0 === o ? void 0 : o.id) || randomID('custom_search_box'),
                ...t.options
            }
        },
        a = { firstGroupName: 'default', ...t.options, otherSuggestions: [...r], fieldSuggestions: [...n] },
        s = buildSearchBox(e, i),
        l = a.otherSuggestions,
        u = a.fieldSuggestions;
    let c = y();
    const p = new Map(),
        f = e => e === s,
        d = e => 'facetSearch' in e.state;
    function h(e) {
        const t = f(e) ? a.firstGroupName : e.groupName,
            r = e.controller;
        let n = [];
        e.isFieldSuggestion
            ? (n = e.getValues().map(r => {
                  if (e.categorypath_separator) {
                      const n = r.split(e.categorypath_separator),
                          o = n[0],
                          i = n[1],
                          a = n.length > 2 ? n[2] : '';
                      return { rawValue: o, highlightedValue: b(o, s.state.value), group: t, path: i, id: a };
                  }
                  return { rawValue: r, highlightedValue: b(r, s.state.value), group: t };
              }))
            : f(e)
            ? (n = e.state.suggestions.map(e => ({ ...e, group: t })))
            : d(r)
            ? (n = r.state.facetSearch.values.map(e => ({
                  rawValue: e.rawValue,
                  highlightedValue: e.displayValue,
                  group: t
              })))
            : (e => 'results' in e.state)(r)
            ? (n = r.state.results.map(e => {
                  var r, n, o, i;
                  const s = HighlightUtils.highlightString({
                      content: e.title,
                      highlights: e.titleHighlights,
                      openingDelimiter:
                          (null ===
                              (n =
                                  null === (r = a.highlightOptions) || void 0 === r
                                      ? void 0
                                      : r.exactMatchDelimiters) || void 0 === n
                              ? void 0
                              : n.open) || '<b>',
                      closingDelimiter:
                          (null ===
                              (i =
                                  null === (o = a.highlightOptions) || void 0 === o
                                      ? void 0
                                      : o.exactMatchDelimiters) || void 0 === i
                              ? void 0
                              : i.close) || '</b>'
                  });
                  return { rawValue: e.title, highlightedValue: s, group: t, result: { ...e } };
              }))
            : console.warn('unexpected customSearchBox provider');
        const o = { name: t, totalCount: n.length };
        g(t, o, n);
    }
    function g(e, t, r) {
        console.log(`groupName: ${e} newSuggestions: ${r.length}`),
            (c.groups = c.groups.filter(t => t.name !== e)),
            c.groups.push(t),
            (c.newSuggestions = c.newSuggestions.filter(t => t.group !== e).concat(r)),
            m();
    }
    function y() {
        return {
            groups: [a.firstGroupName, ...l.map(e => e.groupName), ...u.map(e => e.groupName)].map(e => ({
                name: e,
                totalCount: 0
            })),
            newSuggestions: []
        };
    }
    l.forEach(e => {
        var t;
        const { dispatch: r } = e.engine,
            { registerAdvancedSearchQueries: n } = loadAdvancedSearchQueryActions(e.engine),
            { registerNumberOfResults: o } = loadPaginationActions(e.engine);
        (null == a ? void 0 : a.numberOfSuggestions) && r(o(a.numberOfSuggestions)),
            r(n({ cq: (null == e ? void 0 : e.filter) || '' })),
            null === (t = e.controller) ||
                void 0 === t ||
                t.subscribe(() => {
                    h(e);
                });
    }),
        u.forEach(e => {
            e.subscribe(() => {
                h(e);
            });
        }),
        s.subscribe(() => {
            const e = s.state;
            h(s),
                e.value &&
                    (l.forEach(t => {
                        !(function (e, t) {
                            const r = t.engine,
                                { updateQuery: n } = loadQueryActions(r),
                                { executeSearch: o } = loadSearchActions(r),
                                { logInterfaceLoad: i } = loadSearchAnalyticsActions(r);
                            let a;
                            d(t.controller)
                                ? (t.controller.facetSearch.updateText(e.value), t.controller.facetSearch.search())
                                : e.suggestions.length > 0
                                ? e.suggestions[0].rawValue !== t.lastFirstSuggestion &&
                                  ((a = e.suggestions[0].rawValue),
                                  r.dispatch(n({ q: a })),
                                  r.dispatch(o(i())),
                                  (t.lastFirstSuggestion = e.suggestions[0].rawValue))
                                : '' == t.lastFirstSuggestion ||
                                  ((t.lastFirstSuggestion = ''),
                                  g(t.groupName, { name: t.groupName, totalCount: 0 }, []));
                        })(e, t);
                    }),
                    u.forEach(t => {
                        t.fetchSuggestions(e.value);
                    }));
        });
    function m() {
        p.forEach(e => e());
    }
    function b(e, t) {
        let r = new RegExp(t.replace(/[\^$\\.*+?()[\]{}|]/g, '\\$&'), 'gi');
        return e.replace(r, '<mark>$&</mark>');
    }
    let { clear: _, ...v } = s;
    return {
        clear: () => {
            (c = y()), s.clear(), m();
        },
        ...v,
        submitFirstSearch: t => {
            const { updateQuery: r } = loadQueryActions(e);
            e.dispatch(r({ q: t })),
                e.executeFirstSearch(),
                console.log('console.dir(baseSearchBox.state, 2)'),
                console.dir(s.state, 2),
                console.dir(e.state, 4);
        },
        get state() {
            const e = c.groups,
                t = c.newSuggestions;
            return { ...s.state, groups: e, newSuggestions: t };
        },
        subscribe(e) {
            e();
            const t = Symbol();
            return (
                p.set(t, e),
                () => {
                    p.delete(t);
                }
            );
        }
    };
}
export function buildCustomStandaloneSearchBox(e, t, r, n) {
    const { dispatch: o } = e,
        i = t.options.id || randomID('custom_standalone_search_box'),
        a = { highlightOptions: { ...t.options.highlightOptions }, ...t.options },
        {
            registerStandaloneSearchBox: s,
            updateAnalyticsToSearchFromLink: l,
            fetchRedirectUrl: u
        } = loadStandaloneSearchBoxSetActions(e),
        { selectQuerySuggestion: c } = loadQuerySuggestActions(e),
        { updateQuery: p } = loadQueryActions(e),
        f = buildCustomSearchBox(e, t, r, n);
    return (
        o(s({ id: i, redirectionUrl: a.redirectionUrl })),
        {
            ...f,
            updateText(e) {
                f.updateText(e), o(l({ id: i }));
            },
            selectSuggestion(e) {
                o(c({ id: i, expression: e })), this.submit();
            },
            submit() {
                o(p({ q: this.state.value, enableQuerySyntax: a.enableQuerySyntax })), o(u({ id: i }));
            },
            get state() {
                const t = e.state.standaloneSearchBoxSet[i];
                return {
                    ...f.state,
                    isLoading: null == t ? void 0 : t.isLoading,
                    redirectTo: null == t ? void 0 : t.redirectTo,
                    analytics: null == t ? void 0 : t.analytics
                };
            }
        }
    );
}
var commonjsGlobal =
        'undefined' != typeof globalThis
            ? globalThis
            : 'undefined' != typeof window
            ? window
            : 'undefined' != typeof global
            ? global
            : 'undefined' != typeof self
            ? self
            : {},
    fetchPonyfill = fetch,
    backoff = {},
    options = {},
    __assign =
        (commonjsGlobal && commonjsGlobal.__assign) ||
        function () {
            return (
                (__assign =
                    Object.assign ||
                    function (e) {
                        for (var t, r = 1, n = arguments.length; r < n; r++)
                            for (var o in (t = arguments[r]))
                                Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                        return e;
                    }),
                __assign.apply(this, arguments)
            );
        };
Object.defineProperty(options, '__esModule', { value: !0 });
var defaultOptions = {
    delayFirstAttempt: !1,
    jitter: 'none',
    maxDelay: 1 / 0,
    numOfAttempts: 10,
    retry: function () {
        return !0;
    },
    startingDelay: 100,
    timeMultiple: 2
};
export function getSanitizedOptions(e) {
    var t = __assign(__assign({}, defaultOptions), e);
    return t.numOfAttempts < 1 && (t.numOfAttempts = 1), t;
}
options.getSanitizedOptions = getSanitizedOptions;
var delay_factory = {},
    skipFirst_delay = {},
    delay_base = {},
    jitter_factory = {},
    full_jitter = {};
Object.defineProperty(full_jitter, '__esModule', { value: !0 });
export function fullJitter(e) {
    var t = Math.random() * e;
    return Math.round(t);
}
full_jitter.fullJitter = fullJitter;
var no_jitter = {};
Object.defineProperty(no_jitter, '__esModule', { value: !0 });
export function noJitter(e) {
    return e;
}
(no_jitter.noJitter = noJitter), Object.defineProperty(jitter_factory, '__esModule', { value: !0 });
var full_jitter_1 = full_jitter,
    no_jitter_1 = no_jitter;
export function JitterFactory(e) {
    return 'full' === e.jitter ? full_jitter_1.fullJitter : no_jitter_1.noJitter;
}
(jitter_factory.JitterFactory = JitterFactory), Object.defineProperty(delay_base, '__esModule', { value: !0 });
var jitter_factory_1 = jitter_factory,
    Delay = (function () {
        function e(e) {
            (this.options = e), (this.attempt = 0);
        }
        return (
            (e.prototype.apply = function () {
                var e = this;
                return new Promise(function (t) {
                    return setTimeout(t, e.jitteredDelay);
                });
            }),
            (e.prototype.setAttemptNumber = function (e) {
                this.attempt = e;
            }),
            Object.defineProperty(e.prototype, 'jitteredDelay', {
                get: function () {
                    return jitter_factory_1.JitterFactory(this.options)(this.delay);
                },
                enumerable: !0,
                configurable: !0
            }),
            Object.defineProperty(e.prototype, 'delay', {
                get: function () {
                    var e = this.options.startingDelay,
                        t = this.options.timeMultiple,
                        r = this.numOfDelayedAttempts,
                        n = e * Math.pow(t, r);
                    return Math.min(n, this.options.maxDelay);
                },
                enumerable: !0,
                configurable: !0
            }),
            Object.defineProperty(e.prototype, 'numOfDelayedAttempts', {
                get: function () {
                    return this.attempt;
                },
                enumerable: !0,
                configurable: !0
            }),
            e
        );
    })();
delay_base.Delay = Delay;
var __extends$1 =
        (commonjsGlobal && commonjsGlobal.__extends) ||
        (function () {
            var e = function (t, r) {
                return (
                    (e =
                        Object.setPrototypeOf ||
                        ({ __proto__: [] } instanceof Array &&
                            function (e, t) {
                                e.__proto__ = t;
                            }) ||
                        function (e, t) {
                            for (var r in t) t.hasOwnProperty(r) && (e[r] = t[r]);
                        }),
                    e(t, r)
                );
            };
            return function (t, r) {
                function n() {
                    this.constructor = t;
                }
                e(t, r), (t.prototype = null === r ? Object.create(r) : ((n.prototype = r.prototype), new n()));
            };
        })(),
    __awaiter$1 =
        (commonjsGlobal && commonjsGlobal.__awaiter) ||
        function (e, t, r, n) {
            return new (r || (r = Promise))(function (o, i) {
                function a(e) {
                    try {
                        l(n.next(e));
                    } catch (e) {
                        i(e);
                    }
                }
                function s(e) {
                    try {
                        l(n.throw(e));
                    } catch (e) {
                        i(e);
                    }
                }
                function l(e) {
                    var t;
                    e.done
                        ? o(e.value)
                        : ((t = e.value),
                          t instanceof r
                              ? t
                              : new r(function (e) {
                                    e(t);
                                })).then(a, s);
                }
                l((n = n.apply(e, t || [])).next());
            });
        },
    __generator$1 =
        (commonjsGlobal && commonjsGlobal.__generator) ||
        function (e, t) {
            var r,
                n,
                o,
                i,
                a = {
                    label: 0,
                    sent: function () {
                        if (1 & o[0]) throw o[1];
                        return o[1];
                    },
                    trys: [],
                    ops: []
                };
            return (
                (i = { next: s(0), throw: s(1), return: s(2) }),
                'function' == typeof Symbol &&
                    (i[Symbol.iterator] = function () {
                        return this;
                    }),
                i
            );
            function s(i) {
                return function (s) {
                    return (function (i) {
                        if (r) throw new TypeError('Generator is already executing.');
                        for (; a; )
                            try {
                                if (
                                    ((r = 1),
                                    n &&
                                        (o =
                                            2 & i[0]
                                                ? n.return
                                                : i[0]
                                                ? n.throw || ((o = n.return) && o.call(n), 0)
                                                : n.next) &&
                                        !(o = o.call(n, i[1])).done)
                                )
                                    return o;
                                switch (((n = 0), o && (i = [2 & i[0], o.value]), i[0])) {
                                    case 0:
                                    case 1:
                                        o = i;
                                        break;
                                    case 4:
                                        return a.label++, { value: i[1], done: !1 };
                                    case 5:
                                        a.label++, (n = i[1]), (i = [0]);
                                        continue;
                                    case 7:
                                        (i = a.ops.pop()), a.trys.pop();
                                        continue;
                                    default:
                                        if (
                                            !((o = a.trys),
                                            (o = o.length > 0 && o[o.length - 1]) || (6 !== i[0] && 2 !== i[0]))
                                        ) {
                                            a = 0;
                                            continue;
                                        }
                                        if (3 === i[0] && (!o || (i[1] > o[0] && i[1] < o[3]))) {
                                            a.label = i[1];
                                            break;
                                        }
                                        if (6 === i[0] && a.label < o[1]) {
                                            (a.label = o[1]), (o = i);
                                            break;
                                        }
                                        if (o && a.label < o[2]) {
                                            (a.label = o[2]), a.ops.push(i);
                                            break;
                                        }
                                        o[2] && a.ops.pop(), a.trys.pop();
                                        continue;
                                }
                                i = t.call(e, a);
                            } catch (e) {
                                (i = [6, e]), (n = 0);
                            } finally {
                                r = o = 0;
                            }
                        if (5 & i[0]) throw i[1];
                        return { value: i[0] ? i[1] : void 0, done: !0 };
                    })([i, s]);
                };
            }
        };
Object.defineProperty(skipFirst_delay, '__esModule', { value: !0 });
var delay_base_1$1 = delay_base,
    SkipFirstDelay = (function (e) {
        function t() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            __extends$1(t, e),
            (t.prototype.apply = function () {
                return __awaiter$1(this, void 0, void 0, function () {
                    return __generator$1(this, function (t) {
                        return [2, !!this.isFirstAttempt || e.prototype.apply.call(this)];
                    });
                });
            }),
            Object.defineProperty(t.prototype, 'isFirstAttempt', {
                get: function () {
                    return 0 === this.attempt;
                },
                enumerable: !0,
                configurable: !0
            }),
            Object.defineProperty(t.prototype, 'numOfDelayedAttempts', {
                get: function () {
                    return this.attempt - 1;
                },
                enumerable: !0,
                configurable: !0
            }),
            t
        );
    })(delay_base_1$1.Delay);
skipFirst_delay.SkipFirstDelay = SkipFirstDelay;
var always_delay = {},
    __extends =
        (commonjsGlobal && commonjsGlobal.__extends) ||
        (function () {
            var e = function (t, r) {
                return (
                    (e =
                        Object.setPrototypeOf ||
                        ({ __proto__: [] } instanceof Array &&
                            function (e, t) {
                                e.__proto__ = t;
                            }) ||
                        function (e, t) {
                            for (var r in t) t.hasOwnProperty(r) && (e[r] = t[r]);
                        }),
                    e(t, r)
                );
            };
            return function (t, r) {
                function n() {
                    this.constructor = t;
                }
                e(t, r), (t.prototype = null === r ? Object.create(r) : ((n.prototype = r.prototype), new n()));
            };
        })();
Object.defineProperty(always_delay, '__esModule', { value: !0 });
var delay_base_1 = delay_base,
    AlwaysDelay = (function (e) {
        function t() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return __extends(t, e), t;
    })(delay_base_1.Delay);
(always_delay.AlwaysDelay = AlwaysDelay), Object.defineProperty(delay_factory, '__esModule', { value: !0 });
var skip_first_delay_1 = skipFirst_delay,
    always_delay_1 = always_delay;
export function DelayFactory(e, t) {
    var r = initDelayClass(e);
    return r.setAttemptNumber(t), r;
}
delay_factory.DelayFactory = DelayFactory;
export function initDelayClass(e) {
    return e.delayFirstAttempt ? new always_delay_1.AlwaysDelay(e) : new skip_first_delay_1.SkipFirstDelay(e);
}
var __awaiter =
        (commonjsGlobal && commonjsGlobal.__awaiter) ||
        function (e, t, r, n) {
            return new (r || (r = Promise))(function (o, i) {
                function a(e) {
                    try {
                        l(n.next(e));
                    } catch (e) {
                        i(e);
                    }
                }
                function s(e) {
                    try {
                        l(n.throw(e));
                    } catch (e) {
                        i(e);
                    }
                }
                function l(e) {
                    var t;
                    e.done
                        ? o(e.value)
                        : ((t = e.value),
                          t instanceof r
                              ? t
                              : new r(function (e) {
                                    e(t);
                                })).then(a, s);
                }
                l((n = n.apply(e, t || [])).next());
            });
        },
    __generator =
        (commonjsGlobal && commonjsGlobal.__generator) ||
        function (e, t) {
            var r,
                n,
                o,
                i,
                a = {
                    label: 0,
                    sent: function () {
                        if (1 & o[0]) throw o[1];
                        return o[1];
                    },
                    trys: [],
                    ops: []
                };
            return (
                (i = { next: s(0), throw: s(1), return: s(2) }),
                'function' == typeof Symbol &&
                    (i[Symbol.iterator] = function () {
                        return this;
                    }),
                i
            );
            function s(i) {
                return function (s) {
                    return (function (i) {
                        if (r) throw new TypeError('Generator is already executing.');
                        for (; a; )
                            try {
                                if (
                                    ((r = 1),
                                    n &&
                                        (o =
                                            2 & i[0]
                                                ? n.return
                                                : i[0]
                                                ? n.throw || ((o = n.return) && o.call(n), 0)
                                                : n.next) &&
                                        !(o = o.call(n, i[1])).done)
                                )
                                    return o;
                                switch (((n = 0), o && (i = [2 & i[0], o.value]), i[0])) {
                                    case 0:
                                    case 1:
                                        o = i;
                                        break;
                                    case 4:
                                        return a.label++, { value: i[1], done: !1 };
                                    case 5:
                                        a.label++, (n = i[1]), (i = [0]);
                                        continue;
                                    case 7:
                                        (i = a.ops.pop()), a.trys.pop();
                                        continue;
                                    default:
                                        if (
                                            !((o = a.trys),
                                            (o = o.length > 0 && o[o.length - 1]) || (6 !== i[0] && 2 !== i[0]))
                                        ) {
                                            a = 0;
                                            continue;
                                        }
                                        if (3 === i[0] && (!o || (i[1] > o[0] && i[1] < o[3]))) {
                                            a.label = i[1];
                                            break;
                                        }
                                        if (6 === i[0] && a.label < o[1]) {
                                            (a.label = o[1]), (o = i);
                                            break;
                                        }
                                        if (o && a.label < o[2]) {
                                            (a.label = o[2]), a.ops.push(i);
                                            break;
                                        }
                                        o[2] && a.ops.pop(), a.trys.pop();
                                        continue;
                                }
                                i = t.call(e, a);
                            } catch (e) {
                                (i = [6, e]), (n = 0);
                            } finally {
                                r = o = 0;
                            }
                        if (5 & i[0]) throw i[1];
                        return { value: i[0] ? i[1] : void 0, done: !0 };
                    })([i, s]);
                };
            }
        };
Object.defineProperty(backoff, '__esModule', { value: !0 });
var options_1 = options,
    delay_factory_1 = delay_factory;
export function backOff(e, t) {
    return (
        void 0 === t && (t = {}),
        __awaiter(this, void 0, void 0, function () {
            var r;
            return __generator(this, function (n) {
                switch (n.label) {
                    case 0:
                        return (r = options_1.getSanitizedOptions(t)), [4, new BackOff(e, r).execute()];
                    case 1:
                        return [2, n.sent()];
                }
            });
        })
    );
}
var backOff_1 = (backoff.backOff = backOff),
    BackOff = (function () {
        function e(e, t) {
            (this.request = e), (this.options = t), (this.attemptNumber = 0);
        }
        return (
            (e.prototype.execute = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var e;
                    return __generator(this, function (t) {
                        switch (t.label) {
                            case 0:
                                if (this.attemptLimitReached) return [3, 7];
                                t.label = 1;
                            case 1:
                                return t.trys.push([1, 4, , 6]), [4, this.applyDelay()];
                            case 2:
                                return t.sent(), [4, this.request()];
                            case 3:
                                return [2, t.sent()];
                            case 4:
                                return (
                                    (e = t.sent()), this.attemptNumber++, [4, this.options.retry(e, this.attemptNumber)]
                                );
                            case 5:
                                if (!t.sent() || this.attemptLimitReached) throw e;
                                return [3, 6];
                            case 6:
                                return [3, 0];
                            case 7:
                                throw new Error('Something went wrong.');
                        }
                    });
                });
            }),
            Object.defineProperty(e.prototype, 'attemptLimitReached', {
                get: function () {
                    return this.attemptNumber >= this.options.numOfAttempts;
                },
                enumerable: !0,
                configurable: !0
            }),
            (e.prototype.applyDelay = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (e) {
                        switch (e.label) {
                            case 0:
                                return [4, delay_factory_1.DelayFactory(this.options, this.attemptNumber).apply()];
                            case 1:
                                return e.sent(), [2];
                        }
                    });
                });
            }),
            e
        );
    })();
class ExpiredTokenError extends Error {
    constructor() {
        super(),
            (this.name = 'ExpiredToken'),
            (this.message = 'The token being used to perform the request is expired.');
    }
}
class DisconnectedError extends Error {
    constructor(e, t) {
        super(),
            (this.name = 'Disconnected'),
            (this.message = `Client could not connect to the following URL: ${e}`),
            (this.statusCode = null != t ? t : 0);
    }
}
export function isThrottled(e) {
    return 429 === e;
}
class PlatformClient {
    static async call(e) {
        const t = buildDefaultRequestOptions(e),
            { logger: r } = e,
            n = { ...t },
            { url: o, ...i } = n,
            a = async () => {
                const e = await fetchPonyfill(o, i);
                if (isThrottled(e.status)) throw e;
                return e;
            };
        try {
            const e = await backOff_1(a, {
                retry: e => {
                    const t = e && isThrottled(e.status);
                    return t && r.info('Platform retrying request'), t;
                }
            });
            if (419 === e.status) throw (r.info('Platform renewing token'), new ExpiredTokenError());
            if (404 === e.status) throw new DisconnectedError(o, e.status);
            return r.info({ response: e, requestInfo: n }, 'Platform response'), e;
        } catch (e) {
            return 'Failed to fetch' === e.message ? new DisconnectedError(o) : e;
        }
    }
}
export function buildDefaultRequestOptions(e) {
    const { url: t, method: r, requestParams: n, contentType: o, accessToken: i, signal: a } = e,
        s = encodeBody(n, o);
    return {
        url: t,
        method: r,
        headers: { 'Content-Type': o, Authorization: `Bearer ${i}`, ...e.headers },
        body: s,
        signal: a
    };
}
export function encodeAsFormUrl(e) {
    const t = [];
    for (const r in e) {
        const n = encodeURIComponent(r),
            o = encodeURIComponent(e[r]);
        t.push(`${n}=${o}`);
    }
    return t.join('&');
}
export function canBeFormUrlEncoded(e) {
    return 'object' == typeof e && !!e && Object.values(e).every(isPrimitive);
}
export function isPrimitive(e) {
    return 'string' == typeof e || 'number' == typeof e || 'boolean' == typeof e;
}
export function encodeBody(e, t) {
    return 'application/x-www-form-urlencoded' === t
        ? canBeFormUrlEncoded(e)
            ? encodeAsFormUrl(e)
            : ''
        : JSON.stringify(e);
}
export const baseSearchRequest = (e, t, r, n) => ({
    accessToken: e.accessToken,
    method: t,
    contentType: r,
    url: `${e.url}${n}?${getOrganizationIdQueryParam(e)}`
});
export const getOrganizationIdQueryParam = e => `organizationId=${e.organizationId}`;
export function buildDisconnectedError(e) {
    return { statusCode: e.statusCode, type: e.name, message: e.message };
}
export function buildAPIResponseFromErrorOrThrow(e) {
    if (e instanceof DisconnectedError) return { error: buildDisconnectedError(e) };
    throw e;
}
class SearchAPIClient {
    constructor(e) {
        this.options = e;
    }
    async values(e) {
        let t = {
            ...baseSearchRequest(e, 'POST', 'application/json', '/values'),
            requestParams: pickNonBaseParams(e),
            ...this.options
        };
        const r = await PlatformClient.call(t);
        if (r instanceof Error) throw r;
        return await r.json();
    }
    async plan(e) {
        const t = await PlatformClient.call({
            ...baseSearchRequest(e, 'POST', 'application/json', '/plan'),
            requestParams: pickNonBaseParams(e),
            ...this.options
        });
        if (t instanceof Error) return buildAPIResponseFromErrorOrThrow(t);
        const r = await t.json();
        return isSuccessPlanResponse(r) ? { success: r } : { error: { response: t, body: r } };
    }
}
export function isSuccessPlanResponse(e) {
    return void 0 !== e.preprocessingOutput;
}
export function pickNonBaseParams(e) {
    const { url: t, accessToken: r, organizationId: n, ...o } = e;
    return o;
}
export function tryStringify(e) {
    try {
        return JSON.stringify(e);
    } catch (e) {
        return '"[Circular]"';
    }
}
var quickFormatUnescaped = format$1;
export function format$1(e, t, r) {
    var n = (r && r.stringify) || tryStringify;
    if ('object' == typeof e && null !== e) {
        var o = t.length + 1;
        if (1 === o) return e;
        var i = new Array(o);
        i[0] = n(e);
        for (var a = 1; a < o; a++) i[a] = n(t[a]);
        return i.join(' ');
    }
    if ('string' != typeof e) return e;
    var s = t.length;
    if (0 === s) return e;
    for (var l = '', u = 0, c = -1, p = (e && e.length) || 0, f = 0; f < p; ) {
        if (37 === e.charCodeAt(f) && f + 1 < p) {
            switch (((c = c > -1 ? c : 0), e.charCodeAt(f + 1))) {
                case 100:
                case 102:
                    if (u >= s) break;
                    if (null == t[u]) break;
                    c < f && (l += e.slice(c, f)), (l += Number(t[u])), (c = f + 2), f++;
                    break;
                case 105:
                    if (u >= s) break;
                    if (null == t[u]) break;
                    c < f && (l += e.slice(c, f)), (l += Math.floor(Number(t[u]))), (c = f + 2), f++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (u >= s) break;
                    if (void 0 === t[u]) break;
                    c < f && (l += e.slice(c, f));
                    var d = typeof t[u];
                    if ('string' === d) {
                        (l += "'" + t[u] + "'"), (c = f + 2), f++;
                        break;
                    }
                    if ('function' === d) {
                        (l += t[u].name || '<anonymous>'), (c = f + 2), f++;
                        break;
                    }
                    (l += n(t[u])), (c = f + 2), f++;
                    break;
                case 115:
                    if (u >= s) break;
                    c < f && (l += e.slice(c, f)), (l += String(t[u])), (c = f + 2), f++;
                    break;
                case 37:
                    c < f && (l += e.slice(c, f)), (l += '%'), (c = f + 2), f++, u--;
            }
            ++u;
        }
        ++f;
    }
    return -1 === c ? e : (c < p && (l += e.slice(c)), l);
}
const format = quickFormatUnescaped;
var browser = pino;
const _console = pfGlobalThisOrFallback().console || {},
    stdSerializers = {
        mapHttpRequest: mock,
        mapHttpResponse: mock,
        wrapRequestSerializer: passthrough,
        wrapResponseSerializer: passthrough,
        wrapErrorSerializer: passthrough,
        req: mock,
        res: mock,
        err: asErrValue
    };
function shouldSerialize(e, t) {
    if (Array.isArray(e)) {
        return e.filter(function (e) {
            return '!stdSerializers.err' !== e;
        });
    }
    return !0 === e && Object.keys(t);
}
export function pino(e) {
    (e = e || {}).browser = e.browser || {};
    const t = e.browser.transmit;
    if (t && 'function' != typeof t.send) throw Error('pino: transmit option must have a send function');
    const r = e.browser.write || _console;
    e.browser.write && (e.browser.asObject = !0);
    const n = e.serializers || {},
        o = shouldSerialize(e.browser.serialize, n);
    let i = e.browser.serialize;
    Array.isArray(e.browser.serialize) && e.browser.serialize.indexOf('!stdSerializers.err') > -1 && (i = !1);
    'function' == typeof r && (r.error = r.fatal = r.warn = r.info = r.debug = r.trace = r),
        !1 === e.enabled && (e.level = 'silent');
    const a = e.level || 'info',
        s = Object.create(r);
    s.log || (s.log = noop),
        Object.defineProperty(s, 'levelVal', {
            get: function () {
                return 'silent' === this.level ? 1 / 0 : this.levels.values[this.level];
            }
        }),
        Object.defineProperty(s, 'level', {
            get: function () {
                return this._level;
            },
            set: function (e) {
                if ('silent' !== e && !this.levels.values[e]) throw Error('unknown level ' + e);
                (this._level = e),
                    set(l, s, 'error', 'log'),
                    set(l, s, 'fatal', 'error'),
                    set(l, s, 'warn', 'error'),
                    set(l, s, 'info', 'log'),
                    set(l, s, 'debug', 'log'),
                    set(l, s, 'trace', 'log');
            }
        });
    const l = {
        transmit: t,
        serialize: o,
        asObject: e.browser.asObject,
        levels: ['error', 'fatal', 'warn', 'info', 'debug', 'trace'],
        timestamp: getTimeFunction(e)
    };
    return (
        (s.levels = pino.levels),
        (s.level = a),
        (s.setMaxListeners =
            s.getMaxListeners =
            s.emit =
            s.addListener =
            s.on =
            s.prependListener =
            s.once =
            s.prependOnceListener =
            s.removeListener =
            s.removeAllListeners =
            s.listeners =
            s.listenerCount =
            s.eventNames =
            s.write =
            s.flush =
                noop),
        (s.serializers = n),
        (s._serialize = o),
        (s._stdErrSerialize = i),
        (s.child = function (r, i) {
            if (!r) throw new Error('missing bindings for child Pino');
            (i = i || {}), o && r.serializers && (i.serializers = r.serializers);
            const a = i.serializers;
            if (o && a) {
                var s = Object.assign({}, n, a),
                    l = !0 === e.browser.serialize ? Object.keys(s) : o;
                delete r.serializers, applySerializers([r], l, s, this._stdErrSerialize);
            }
            function u(e) {
                (this._childLevel = 1 + (0 | e._childLevel)),
                    (this.error = bind(e, r, 'error')),
                    (this.fatal = bind(e, r, 'fatal')),
                    (this.warn = bind(e, r, 'warn')),
                    (this.info = bind(e, r, 'info')),
                    (this.debug = bind(e, r, 'debug')),
                    (this.trace = bind(e, r, 'trace')),
                    s && ((this.serializers = s), (this._serialize = l)),
                    t && (this._logEvent = createLogEventShape([].concat(e._logEvent.bindings, r)));
            }
            return (u.prototype = this), new u(this);
        }),
        t && (s._logEvent = createLogEventShape()),
        s
    );
}
(pino.levels = {
    values: { fatal: 60, error: 50, warn: 40, info: 30, debug: 20, trace: 10 },
    labels: { 10: 'trace', 20: 'debug', 30: 'info', 40: 'warn', 50: 'error', 60: 'fatal' }
}),
    (pino.stdSerializers = stdSerializers),
    (pino.stdTimeFunctions = Object.assign(
        {},
        { nullTime: nullTime, epochTime: epochTime, unixTime: unixTime, isoTime: isoTime }
    ));
export function set(e, t, r, n) {
    const o = Object.getPrototypeOf(t);
    (t[r] = t.levelVal > t.levels.values[r] ? noop : o[r] ? o[r] : _console[r] || _console[n] || noop), wrap(e, t, r);
}
export function wrap(e, t, r) {
    var n;
    (e.transmit || t[r] !== noop) &&
        (t[r] =
            ((n = t[r]),
            function () {
                const o = e.timestamp(),
                    i = new Array(arguments.length),
                    a = Object.getPrototypeOf && Object.getPrototypeOf(this) === _console ? _console : this;
                for (var s = 0; s < i.length; s++) i[s] = arguments[s];
                if (
                    (e.serialize &&
                        !e.asObject &&
                        applySerializers(i, this._serialize, this.serializers, this._stdErrSerialize),
                    e.asObject ? n.call(a, asObject(this, r, i, o)) : n.apply(a, i),
                    e.transmit)
                ) {
                    const n = e.transmit.level || t.level,
                        a = pino.levels.values[n],
                        s = pino.levels.values[r];
                    if (s < a) return;
                    transmit(
                        this,
                        {
                            ts: o,
                            methodLevel: r,
                            methodValue: s,
                            transmitLevel: n,
                            transmitValue: pino.levels.values[e.transmit.level || t.level],
                            send: e.transmit.send,
                            val: t.levelVal
                        },
                        i
                    );
                }
            }));
}
export function asObject(e, t, r, n) {
    e._serialize && applySerializers(r, e._serialize, e.serializers, e._stdErrSerialize);
    const o = r.slice();
    let i = o[0];
    const a = {};
    n && (a.time = n), (a.level = pino.levels.values[t]);
    let s = 1 + (0 | e._childLevel);
    if ((s < 1 && (s = 1), null !== i && 'object' == typeof i)) {
        for (; s-- && 'object' == typeof o[0]; ) Object.assign(a, o.shift());
        i = o.length ? format(o.shift(), o) : void 0;
    } else 'string' == typeof i && (i = format(o.shift(), o));
    return void 0 !== i && (a.msg = i), a;
}
export function applySerializers(e, t, r, n) {
    for (const o in e)
        if (n && e[o] instanceof Error) e[o] = pino.stdSerializers.err(e[o]);
        else if ('object' == typeof e[o] && !Array.isArray(e[o]))
            for (const n in e[o]) t && t.indexOf(n) > -1 && n in r && (e[o][n] = r[n](e[o][n]));
}
export function bind(e, t, r) {
    return function () {
        const n = new Array(1 + arguments.length);
        n[0] = t;
        for (var o = 1; o < n.length; o++) n[o] = arguments[o - 1];
        return e[r].apply(this, n);
    };
}
export function transmit(e, t, r) {
    const n = t.send,
        o = t.ts,
        i = t.methodLevel,
        a = t.methodValue,
        s = t.val,
        l = e._logEvent.bindings;
    applySerializers(
        r,
        e._serialize || Object.keys(e.serializers),
        e.serializers,
        void 0 === e._stdErrSerialize || e._stdErrSerialize
    ),
        (e._logEvent.ts = o),
        (e._logEvent.messages = r.filter(function (e) {
            return -1 === l.indexOf(e);
        })),
        (e._logEvent.level.label = i),
        (e._logEvent.level.value = a),
        n(i, e._logEvent, s),
        (e._logEvent = createLogEventShape(l));
}
export function createLogEventShape(e) {
    return { ts: 0, messages: [], bindings: e || [], level: { label: '', value: 0 } };
}
export function asErrValue(e) {
    const t = { type: e.constructor.name, msg: e.message, stack: e.stack };
    for (const r in e) void 0 === t[r] && (t[r] = e[r]);
    return t;
}
export function getTimeFunction(e) {
    return 'function' == typeof e.timestamp ? e.timestamp : !1 === e.timestamp ? nullTime : epochTime;
}
function mock() {
    return {};
}
function passthrough(e) {
    return e;
}
function noop() {}
function nullTime() {
    return !1;
}
function epochTime() {
    return Date.now();
}
function unixTime() {
    return Math.round(Date.now() / 1e3);
}
function isoTime() {
    return new Date(Date.now()).toISOString();
}
export function pfGlobalThisOrFallback() {
    function e(e) {
        return void 0 !== e && e;
    }
    try {
        return (
            'undefined' != typeof globalThis ||
                Object.defineProperty(Object.prototype, 'globalThis', {
                    get: function () {
                        return delete Object.prototype.globalThis, (this.globalThis = this);
                    },
                    configurable: !0
                }),
            globalThis
        );
    } catch (t) {
        return e(self) || e(window) || e(this) || {};
    }
}
export function buildLogger(e) {
    return browser({
        name: '@sbr/headless-extension',
        level: (null == e ? void 0 : e.level) || 'warn',
        formatters: { log: null == e ? void 0 : e.logFormatter },
        browser: { transmit: { send: (null == e ? void 0 : e.browserPostLogHook) || (() => {}) } }
    });
}
export function buildFieldSuggestion(e, t, r, n, o, i, a, s, l) {
    let u = [],
        c = '';
    const p = buildLogger({}),
        f = new SearchAPIClient({ logger: p });
    let d = '';
    const h = [];
    return {
        isFieldSuggestion: !0,
        groupName: e,
        field: i,
        filter: a,
        flex_mode: s,
        categorypath_separator: l,
        getValues: () => u,
        fetchSuggestions: e => {
            if (!e.trim() || e === c) return;
            c = e;
            let p = e,
                g = 'wildcard';
            const y = (function (e) {
                const t = e.replace(/^\s*(\d+)-(\d+)\s*$/g, '($1$2|$1-$2)');
                return { isProductIdSearch: t !== e, newPattern: t !== e ? t : '' };
            })(e);
            y.isProductIdSearch
                ? ((p = `.*${y.newPattern}.*`), (g = 'regularexpression'))
                : s
                ? ((p = e.trim().replace(/[^a-zA-Z0-9]+/gi, '\\W+')), (p = `.*${p}.*`), (g = 'regularexpression'))
                : l
                ? ((p = e.trim().replace(/[^a-zA-Z0-9]+/gi, '\\W+')), (p = `.*${p}.*${l}.*`), (g = 'regularexpression'))
                : (p = `*${p}*`);
            const m = {
                url: t + '/rest/search/v2',
                accessToken: r,
                organizationId: n,
                searchHub: o,
                maximumNumberOfValues: 5,
                field: i,
                pattern: p,
                patternType: g
            };
            a && (m.constantQueryOverride = a),
                f.values(m).then(e => {
                    const t = e.values.map(e => e.value),
                        r = JSON.stringify(t);
                    r !== d && ((u = t), (d = r)),
                        h.forEach(e => {
                            e();
                        });
                });
        },
        subscribe(e) {
            h.push(e);
        }
    };
}
